import React, { useEffect, useState } from "react";
import moment from "moment";
import styled from "styled-components";
import {
  Card,
  Table,
  Select,
  TablePanel,
  MonthPicker,
  UserAvatar,
  CountryFlag,
} from "components/common";
import { callGetApiWithAuth } from "utils/api";
import { asPrice, asVolume } from "utils/text";
import { Badge } from "antd";
import { varLabel } from "common/var";

export default function TableView() {
  const [tableData, setTableData] = useState([]);
  const [searchParam, setSearchParam] = useState({
    search_type: "",
    from: moment().startOf("month").format("YYYY-MM-DD"),
    to: moment().endOf("month").format("YYYY-MM-DD"),
  });
  const [isLoading, setIsLoading] = useState(false);
  const [paginationParam, setPaginationParam] = useState({
    currentPage: 1,
    perPage: 15,
    total: 0,
  });

  const onGetTableData = (res) => {
    setTableData(res.data.data);
    setPaginationParam({
      ...paginationParam,
      currentPage: res.data.current_page,
      total: res.data.total,
    });
    setIsLoading(false);
  };
  const onFailTableData = () => {
    setIsLoading(false);
  };
  const loadTableData = (paginationParam0) => {
    setIsLoading(true);
    const params = {
      page: paginationParam0.currentPage,
      per_page: paginationParam0.perPage,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    callGetApiWithAuth(
      `report/gw_redeem_report/list?${q}`,
      onGetTableData,
      onFailTableData
    );
  };

  const onPageChange = (page) => {
    setPaginationParam(prev => ({
      ...prev,
      currentPage: page
    }));
  
    loadTableData({
      ...paginationParam,
      currentPage: page,
    });
  };

  
  useEffect(() => {
    loadTableData(paginationParam);
  }, []);

  return (
    <Wrapper>
      <TablePanel
        title={
          "Gift Wallet Redeem Report (Promotion Period: 2026-04-28 PST ~ 2026-05-04 PST)"
        }
        data={tableData}
        loading={isLoading}
        onPageChange={onPageChange}
        paginationParam={paginationParam}
        columns={[
          {
            title: "#",
            key: "s_no",
            render: (_, __, index) => <span>{index + 1}</span>,
          },
          {
            title: "Name",
            key: "name",
            render: (_, record) => (
              <UserAvatar
                image={record.image}
                title={`${record.first_name} ${record.last_name}`}
              />
            ),
          },
          {
            title: "Type",
            key: "type",
            render: (_, record) => (
              <span className={`user-type ${record.type == 1? 'affiliate':'preferred'}`}>{varLabel("user.type", record.type)}</span>
            ),
          },
          {
            title: "Country",
            key: "county",
            render: (_, record) => (
              <div>
                <CountryFlag country={record.country} />
              </div>
            ),
          },
          {
            title: "GW Consumed Amount",
            key: "pe",
            render: (_, record) => <span>{(record.consume_amount)}</span>,
          },
          {
            title: "Is Redeemed?",
            key: "pev",
            render: (_, record) => <span>{record.is_redeemed? '✅ Yes' : '❌ No'}</span>,
          },
        ]}
      />
    </Wrapper>
  );
}

export const Wrapper = styled.div`
  .top-header {
    .ant-select {
      width: 220px;
      .ant-select-selector {
        height: 40px !important;
        padding-top: 4px !important;
      }
    }
    .ant-select-selection-item, .ant-picker-input > input {
      color: #919eab !important;
    }
  }

  .ant-picker {
    height: 40px !important;
    border-radius: 8px !important;
    .ant-picker-input > input {
      color: #919eab !important;
    }
  }

  @media (max-width: 1250px) {
    .ant-table {
      overflow-x: scroll;
      .ant-table-container {
        width: 900px;
      }
    }
  }
  @media (max-width: 600px) {
    .panelHead {
      display: block;
      h4 {
        padding-bottom: 24px;
      }
      .ant-select,
      .ant-picker {
        width: 100% !important;
      }
    }
  }

  /* @media (max-width: 576px) {
    .date-picker {
      flex-direction: column;
      width: 100%;
      div {
        width: 100%;
      }
      .ant-select {
        width: 100% !important;
        margin-left: 0px !important;
        margin-bottom: 10px;
      }
    }
  }
  .user-name {
    img {
      width: 28px;
      height: 28px;
      margin-right: 7px;
    }
  }
  @media (max-width: 1024px) {
    .table-container {
      .ant-table {
        overflow-x: scroll;
        .ant-table-container {
          width: 800px;
        }
      }
    }
  } */
  .user-type.affiliate {
      background: #0abab5;
  }
  .user-type.preferred {
    background: #aaa;
  }
    .user-type {
      padding: 2px;
      border-radius: 2px;
    }
`;
